import * as React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import MainLayoutContainer from 'containers/MainLayout'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import ObjectsAndPropertiesTable from './components/Table'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// context
import { ObjectsAndPropertiesPageContext } from 'containers/ObjectsAndProperties/Register/layers/API'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const ObjectsAndPropertiesContainer: React.FC = () => {
  const { isLoading } = React.useContext(ObjectsAndPropertiesPageContext)

  return (
    <>
      <Helmet>
        <title>Skefto - Objects & Properties</title>
      </Helmet>
      <MainLayoutContainer isLoading={isLoading}>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <ObjectsAndPropertiesTable />
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default ObjectsAndPropertiesContainer
